import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Spin, Form, message, Button } from 'antd';
import { Config } from '../../public/js/config';

import './completeWPAFormSelectLanguage.css';
import '../newMain/newMain.css';


const CompleteWPAForm = (props) => {

    const history = useHistory();
    const { authorizationCode } = useParams();

    const [isLoad, setIsLoad] = useState(false);
    const [isShow, setIsShow] = useState(true);
    const [form] = Form.useForm();

    useEffect(() => {
        if (authorizationCode) {
            checkCode()
        } else {
            message.error("Link has failed.");
            setIsShow(false);
        }
    }, []);

    const checkCode = () => {
        if(isLoad) {
            return;
        }
        let model = {authorizationCode: authorizationCode};
        setIsLoad(true);
        fetch(Config.apiServer + "partner/wpaAppl/checkAuthorizationCode", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsShow(true)
            } else {
                message.error(data.msg);
                setIsShow(false);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const jump = (path, lang) => {
        history.push(path + '/' + authorizationCode + '/' + lang);
    }

    return (
        <div id="container" className='websiteTemplate completeWPAFormSelectLanguage'>
            {isShow ? <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className='detailTitle'></div>
                    </div>
                </div>
                <div className='websiteSysContentBox'>
                    <Form form={form}>
                        <div className='marginBot'>
                            <div className='contentTitle'>
                                香港高等教育科技学院
                            </div>
                            <div className='contentTitle'>
                                香港高等教育科技學院
                            </div>
                            <div className='contentTitle'>
                                TECHNOLOGICAL AND HIGHER EDUCATION INSTITUTE OF HONG KONG
                            </div>
                        </div>
                        <div className='marginBot'>
                            <div className='contentTitle'>
                                工作综合学习- 学生工作表现评估
                            </div>
                            <div className='contentTitle'>
                                工作綜合學習- 學生工作表現評估
                            </div>
                            <div className='contentTitle'>
                                WIL - Student Work Performance Appraisal
                            </div>
                        </div>
                        <div className='marginBot2'>
                            <div className='contentTitle'>
                                请确保在填写表格之前，已准备好所有参考资料，并一次完成评估。本系统不支援储存草稿。若闲置超过60分钟，系统会自动登出，已填写的资料将不被保留，届时需重新输入表格。谢谢！
                            </div>
                            <div className='contentTitle'>
                                請確保在填寫表格之前，已準備好所有參考資料，並一次完成評估。本系統不支援儲存草稿。若閒置超過60分鐘，系統會自動登出，已填寫的資料將不被保留，屆時需重新輸入表格。謝謝！
                            </div>
                            <div className='contentTitle'>
                                Please complete the assessment in one session, with all reference materials ready. No draft saving is available, and the session will timeout after 60 minutes of inactivity. Thank you!
                            </div>
                        </div>
                        <div className=''>
                            <div className='contentTitle'>
                                请选择你的语言
                            </div>
                            <div className='contentTitle'>
                                請選擇你的語言
                            </div>
                            <div className='contentTitle'>
                                Please select your language
                            </div>
                        </div>
                        <div className=''>
                            <div className='contentTitleDisplay'>
                            {/* <Button type="text">Text</Button> */}
                                <Button  className='websiteSysButton signatureButton marginZY' onClick={() => jump("/completeWPAForm", "SC")}>简体中文</Button>
                                <Button  className='websiteSysButton signatureButton marginZY' onClick={() => jump("/completeWPAForm", "TC")}>繁體中文</Button>
                                <Button  className='websiteSysButton signatureButton marginZY' onClick={() => jump("/completeWPAForm", "EN")}>English</Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Spin>
                : <div className='contentTitle'>Link has failed.</div>
            }
            
        </div>
    )

}

export default CompleteWPAForm;